import { ComponentInterface } from "@stencil/core";
import { HostRef } from "@stencil/core/internal";

const destroyRef = (elm: HTMLElement): ComponentInterface => {
  const ref: HostRef = (window as any).stencil.getHostRef(elm);
  const instance = ref?.$lazyInstance$;
  const instanceEvents = [];

  if (elm.tagName === 'COREO-MAPBOX-MAP') {
    return;
  }

  if (instance) {
    (elm as any).lastFocus = undefined;
    ref.$hostElement$ = undefined;
    ref.$ancestorComponent$ = undefined;
    ref.$lazyInstance$ = undefined;
    ref.$vnode$ = undefined;
    ref.$onReadyPromise$ = undefined;
    ref.$onReadyResolve$ = undefined;
    ref.$onInstancePromise$ = undefined;
    ref.$onInstanceResolve$ = undefined;
    ref.$instanceValues$ = undefined;
    ref.$cmpMeta$ = undefined;

    if (ref.$rmListeners$) {
      ref.$rmListeners$.map((rmListener) => rmListener());
      ref.$rmListeners$ = undefined;
    }
    delete instance.nativeInput;

    // Try to detect any event handlers
    for (const p in instance) {
      if (p[0] === 'o' && p[1] == 'n' && p[2].toUpperCase() === p[2]) {
        instanceEvents.push([p.slice(2).toLowerCase(), instance[p]]);
        instance[p] = undefined;
      }
    }
  }

  for (const i of instanceEvents) {
    elm.removeEventListener(i[0], i[1]);
    elm['on' + i[0]] = undefined;
    elm[i[0]] = undefined;
  }

  for (const child of Array.from(elm.children ?? [])) {
    instanceEvents.map(i => child.removeEventListener(i[0], i[1]));
    destroyRef(child as HTMLElement);
  }

  for (const shadowChild of Array.from(elm.shadowRoot?.children ?? [])) {
    instanceEvents.map(i => shadowChild.removeEventListener(i[0], i[1]));
    destroyRef(shadowChild as HTMLElement);
  }

  // Remove the element
  try {
    elm.remove();
  } catch (e) {
    console.warn(e);
  }

  return instance;

};

class StencilService {

  private constructor() { };

  public static instance: StencilService = new StencilService();

  init() {
    document.addEventListener('ionModalDidDismiss', (e: Event) => {
      const stencil: any = (window as any).stencil ?? {};
      const modal = e.target as HTMLIonModalElement;

      if ('getHostRef' in stencil) {
        const children = [
          ...Array.from(modal.children),
          ...Array.from(modal.shadowRoot.children)
        ];
        setTimeout(() => {
          // If the modal is no longer in the dom, clean it up
          if (!document.body.contains(modal)) {
            console.log('Cleaning Modal');
            [...children, modal].map(elm => destroyRef(elm as HTMLElement));
          }
        }, 1000);
      }
    });
  }
}
export default StencilService;
